import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

// Connects to data-controller="ui--remote-toggle"
// Sends toggle state to server when changed
export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "post" }
  }

  async toggle(event) {
    const checkbox = event.target
    const checked = checkbox.checked
    const method = this.methodValue.toLowerCase()

    const options = { responseKind: "turbo-stream" }

    if (method === "get") {
      options.query = { checked }
    } else {
      options.body = { checked }
    }

    this.element.setAttribute("data-loading", "")

    try {
      const request = new FetchRequest(method, this.urlValue, options)
      const response = await request.perform()

      if (!response.ok) {
        checkbox.checked = !checked
        this.showError()
      }
    } catch {
      checkbox.checked = !checked
      this.showError()
    } finally {
      this.element.removeAttribute("data-loading")
    }
  }

  showError() {
    this.element.setAttribute("data-error", "")
    setTimeout(() => this.element.removeAttribute("data-error"), 2000)
  }
}
